export const ASSESSMENT_STEPS = [
  { key: 'member', label: 'Member' },
  { key: 'health', label: 'Health' },
  { key: 'posture', label: 'Posture' },
  { key: 'fms', label: 'Movement' },
  { key: 'mobility', label: 'Mobility' },
  { key: 'fitness', label: 'Fitness' },
  { key: 'summary', label: 'Summary' },
];

export const ASSESSMENT_STATUS_TABS = [
  { label: 'All', value: 'all', accent: '#868dfb' },
  { label: 'Draft', value: 'draft', accent: '#f5a623' },
  { label: 'Completed', value: 'completed', accent: '#4cceac' },
  { label: 'Reviewed', value: 'reviewed', accent: '#4dabf7' },
];

export const POSTURE_FIELDS = [
  { key: 'head', label: 'Head Position', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'forward_head', label: 'Forward Head' },
  ]},
  { key: 'shoulders', label: 'Shoulders', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'rounded', label: 'Rounded' },
  ]},
  { key: 'thoracic_spine', label: 'Thoracic Spine', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'kyphosis', label: 'Kyphosis' },
  ]},
  { key: 'lumbar_spine', label: 'Lumbar Spine', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'lordosis', label: 'Lordosis' },
  ]},
  { key: 'knees', label: 'Knees', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'valgus', label: 'Valgus' },
    { value: 'varus', label: 'Varus' },
  ]},
  { key: 'feet', label: 'Feet', options: [
    { value: 'normal', label: 'Normal' },
    { value: 'pronation', label: 'Pronation' },
    { value: 'supination', label: 'Supination' },
  ]},
];

export const FMS_TESTS = [
  { key: 'overhead_squat', label: 'Overhead Squat' },
  { key: 'single_leg_balance', label: 'Single Leg Balance' },
  { key: 'push_assessment', label: 'Push Assessment' },
  { key: 'shoulder_mobility', label: 'Shoulder Mobility' },
  { key: 'active_straight_leg_raise', label: 'Active Straight Leg Raise' },
  { key: 'lunge_assessment', label: 'Lunge Assessment' },
  { key: 'sit_to_stand', label: 'Sit-to-Stand' },
];

export const MOBILITY_TESTS = [
  { key: 'ankle_mobility', label: 'Ankle Mobility' },
  { key: 'deep_squat_mobility', label: 'Deep Squat Mobility' },
  { key: 'hip_mobility', label: 'Hip Mobility' },
  { key: 'hamstring_mobility', label: 'Hamstring Mobility' },
  { key: 'hip_rotation', label: 'Hip Rotation' },
  { key: 'shoulder_mobility', label: 'Shoulder Mobility' },
  { key: 'thoracic_mobility', label: 'Thoracic Mobility' },
  { key: 'shoulder_flexion', label: 'Shoulder Flexion' },
];

export const SCORE_LABELS = [
  { value: 0, label: '0 — Pain' },
  { value: 1, label: '1 — Limited' },
  { value: 2, label: '2 — Acceptable' },
  { value: 3, label: '3 — Excellent' },
];

export const CORRECTIVE_PRIORITIES = [
  { value: 'mobility', label: 'Mobility' },
  { value: 'stability', label: 'Stability' },
  { value: 'core_strength', label: 'Core Strength' },
  { value: 'weight_loss', label: 'Weight Loss' },
  { value: 'posture_correction', label: 'Posture Correction' },
  { value: 'cardiovascular_fitness', label: 'Cardiovascular Fitness' },
  { value: 'athletic_performance', label: 'Athletic Performance' },
];

export const CARDIO_OPTIONS = [
  { value: 'six_min_walk', label: '6-Minute Walk Test (distance in meters)' },
  { value: 'three_min_step', label: '3-Minute Step Test (recovery HR bpm)' },
];

/** Placeholder + helper text shown on assessment inputs. */
export const HEALTH_FIELD_HINTS = {
  blood_pressure: {
    placeholder: '120/80',
    helperText: 'Systolic/diastolic format, e.g. 120/80',
  },
  resting_heart_rate: {
    placeholder: '72',
    helperText: 'Resting heart rate in beats per minute',
  },
  height_cm: {
    placeholder: '175',
    helperText: 'Height in centimetres (cm)',
  },
  weight_kg: {
    placeholder: '78.5',
    helperText: 'Weight in kilograms (kg)',
  },
  waist_cm: {
    placeholder: '88',
    helperText: 'Waist circumference in cm',
  },
  hip_cm: {
    placeholder: '98',
    helperText: 'Hip circumference in cm',
  },
  body_fat_pct: {
    placeholder: '22.5',
    helperText: 'Body fat percentage, e.g. 22.5',
  },
  medical_conditions: {
    placeholder: 'e.g. Mild hypertension, controlled with medication',
    helperText: 'List relevant conditions or enter None',
  },
  medications: {
    placeholder: 'e.g. None, or Metformin 500mg daily',
    helperText: 'Current medications or None',
  },
  exercise_experience: {
    placeholder: 'e.g. Gym 2x/week for 1 year, occasional running',
    helperText: 'Past and current exercise habits',
  },
  emergency_contact: {
    placeholder: 'e.g. Jane Doe — 0779876543 (Spouse)',
    helperText: 'Name, phone, and relationship if different from registration',
  },
  notes: {
    placeholder: 'e.g. No acute complaints during screening',
    helperText: 'Additional health screening notes',
  },
  risk_override_comment: {
    placeholder: 'e.g. Cleared by physician despite elevated BMI',
    helperText: 'Explain why risk category was overridden',
  },
};

export const FITNESS_FIELD_HINTS = {
  cardio_result_walk: {
    placeholder: '520',
    helperText: '6-minute walk distance in metres, e.g. 520',
  },
  cardio_result_step: {
    placeholder: '95',
    helperText: 'Recovery heart rate in bpm after step test, e.g. 95',
  },
  cardio_result: {
    placeholder: '520',
    helperText: 'Walk test: metres · Step test: recovery HR (bpm)',
  },
  push_ups: {
    placeholder: '18',
    helperText: 'Maximum push-ups in one set',
  },
  plank_seconds: {
    placeholder: '45',
    helperText: 'Plank hold duration in seconds',
  },
  sit_to_stand_30s: {
    placeholder: '14',
    helperText: 'Repetitions in 30 seconds',
  },
  sit_and_reach_cm: {
    placeholder: '12',
    helperText: 'Reach distance in cm (+ or −)',
  },
  balance_left_seconds: {
    placeholder: '25',
    helperText: 'Single-leg balance hold, left side (seconds)',
  },
  balance_right_seconds: {
    placeholder: '22',
    helperText: 'Single-leg balance hold, right side (seconds)',
  },
};

export const POSTURE_NOTES_HINT = {
  placeholder: 'e.g. Forward head noted during static standing assessment',
  helperText: 'Observations not covered by the posture selections',
};

export const SUMMARY_FIELD_HINTS = {
  strengths: {
    placeholder: 'e.g. Good upper-body endurance\nAcceptable squat pattern',
    helperText: 'One strength per line',
  },
  areas_for_improvement: {
    placeholder: 'e.g. Hip mobility restrictions\nCore endurance below target',
    helperText: 'One area per line',
  },
  trainer_notes: {
    placeholder: 'e.g. Recommend corrective work 2x/week before heavy loading',
    helperText: 'Programming notes for the member',
  },
};

export const HEALTH_NUMERIC_FIELDS = [
  { key: 'blood_pressure', label: 'Blood Pressure' },
  { key: 'resting_heart_rate', label: 'Resting Heart Rate (bpm)', type: 'number' },
  { key: 'height_cm', label: 'Height (cm)', type: 'number', required: true },
  { key: 'weight_kg', label: 'Weight (kg)', type: 'number', required: true },
  { key: 'waist_cm', label: 'Waist Circumference (cm)', type: 'number' },
  { key: 'hip_cm', label: 'Hip Circumference (cm)', type: 'number' },
  { key: 'body_fat_pct', label: 'Body Fat %', type: 'number' },
];

export const FITNESS_INPUT_FIELDS = [
  { key: 'push_ups', label: 'Push-Ups' },
  { key: 'plank_seconds', label: 'Plank Hold (seconds)' },
  { key: 'sit_to_stand_30s', label: '30s Sit-to-Stand' },
  { key: 'sit_and_reach_cm', label: 'Sit-and-Reach (cm)' },
  { key: 'balance_left_seconds', label: 'Single Leg Balance — Left (sec)' },
  { key: 'balance_right_seconds', label: 'Single Leg Balance — Right (sec)' },
];

export const emptyHealthScreening = () => ({
  blood_pressure: '',
  resting_heart_rate: '',
  height_cm: '',
  weight_kg: '',
  waist_cm: '',
  hip_cm: '',
  body_fat_pct: '',
  medical_conditions: '',
  medications: '',
  exercise_experience: '',
  emergency_contact: '',
  notes: '',
  risk_override_comment: '',
});

export const emptyPosture = () => ({
  head: '',
  shoulders: '',
  thoracic_spine: '',
  lumbar_spine: '',
  knees: '',
  feet: '',
  notes: '',
});

export const emptyFms = () =>
  Object.fromEntries(FMS_TESTS.map((t) => [t.key, '']));

export const emptyMobility = () =>
  Object.fromEntries(MOBILITY_TESTS.map((t) => [t.key, '']));

export const emptyFitness = () => ({
  cardio_method: '',
  cardio_result: '',
  push_ups: '',
  plank_seconds: '',
  sit_to_stand_30s: '',
  sit_and_reach_cm: '',
  balance_left_seconds: '',
  balance_right_seconds: '',
});

export const emptySummary = () => ({
  strengths: '',
  areas_for_improvement: '',
  corrective_priorities: [],
  trainer_notes: '',
});

const stringifySectionNumbers = (section, keys) => {
  const result = {};
  keys.forEach((key) => {
    const value = section?.[key];
    result[key] = value === null || value === undefined || value === '' ? '' : String(value);
  });
  return result;
};

const sanitizeSection = (defaults, section, keys) => {
  const merged = { ...defaults, ...(section || {}) };
  keys.forEach((key) => {
    const value = merged[key];
    if (Array.isArray(value)) return;
    if (value === null || value === undefined) {
      merged[key] = '';
    } else if (value !== '' && typeof value !== 'object') {
      merged[key] = String(value);
    }
  });
  return merged;
};

export const assessmentFormValues = (assessment) => {
  const fms = { ...emptyFms(), ...(assessment?.functional_movement || {}) };
  const mobility = { ...emptyMobility(), ...(assessment?.mobility || {}) };
  const healthKeys = Object.keys(emptyHealthScreening());
  const fitnessKeys = Object.keys(emptyFitness());

  return {
    health_screening: sanitizeSection(
      emptyHealthScreening(),
      assessment?.health_screening,
      healthKeys,
    ),
    posture: sanitizeSection(emptyPosture(), assessment?.posture, Object.keys(emptyPosture())),
    functional_movement: {
      ...emptyFms(),
      ...stringifySectionNumbers(fms, FMS_TESTS.map((t) => t.key)),
    },
    mobility: {
      ...emptyMobility(),
      ...stringifySectionNumbers(mobility, MOBILITY_TESTS.map((t) => t.key)),
    },
    fitness_testing: sanitizeSection(
      emptyFitness(),
      assessment?.fitness_testing,
      fitnessKeys,
    ),
    summary: sanitizeSection(emptySummary(), assessment?.summary, Object.keys(emptySummary())),
  };
};

export const formatRiskLabel = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, ' ') : '—';

export const formatMobilityClass = (value) => {
  const map = {
    excellent: 'Excellent',
    moderate_restriction: 'Moderate Restriction',
    significant_restriction: 'Significant Restriction',
  };
  return map[value] || formatRiskLabel(value);
};
